import moment from "moment";

function withinDateRange(datestr, { from, to }) {
  const date = moment(datestr);
  if (from && to) {
    return date >= from && date <= to;
  } else {
    return true;
  }
}

export { withinDateRange };



// WEBPACK FOOTER //
// ./src/utilities/filter.js